import React from 'react';
import classNames from 'classnames';
import './PdfPreviewButton.scss';

type PdfPreviewButtonProps = { onClick?: () => void; icon: React.ReactNode };

export const PdfPreviewButton: React.FC<PdfPreviewButtonProps> = (props: PdfPreviewButtonProps) => {
  return (
    <div className={classNames('pdf-preview-button')} onClick={props.onClick}>
      {props.icon}
    </div>
  );
};
